var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSmallLinkedinIcon = props => {
  const _uid = React.useId().replace(/:/g, '');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    fill: "none",
    viewBox: "0 0 13 13"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#" + _uid + "small-linkedin-icon_svg__a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1C64F2",
    d: "M11.612.5H1.386a.875.875 0 0 0-.886.865v10.268c0 .478.396.867.886.867h10.226c.49 0 .888-.39.888-.865V1.365A.877.877 0 0 0 11.612.5M4.06 10.726H2.28V4.998H4.06zm-.89-6.509a1.032 1.032 0 1 1-.004-2.063 1.032 1.032 0 0 1 .004 2.063m7.556 6.509h-1.78V7.94c0-.663-.01-1.518-.925-1.518-.926 0-1.066.724-1.066 1.472v2.83H5.178V4.999h1.706v.782h.024c.237-.45.818-.925 1.683-.925 1.802 0 2.135 1.186 2.135 2.728z"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: _uid + "small-linkedin-icon_svg__a"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5.5h12v12H.5z"
  })))));
};
export { SvgSmallLinkedinIcon as ReactComponent };
export default __webpack_public_path__ + "651495ddd92bfb8be6a7bbb20838b6a4.svg";